export default __webpack_public_path__ + "static/designer-hikes@2x-74a2653b6abdb0b4140033af38eb21ab.png";